import React from 'react'
import IconPreloader from 'loankeeper-common/components/IconPreloader'
import { DocumentTitle } from 'shared'

import NavigationPanel from './Navigation/NavigationPanel'
import QuickAccessToolbar from './Navigation/QuickAccessToolbar'

import { OpenPagesProvider } from './OpenedPages'
import StatusBar from './StatusBar'

import ChangeDateTimeModal from './Auth/ChangeDateTimeModal'
import UserActivityNotifications from './UserActivityNotifications'
import UserSTKNotifications from './UserActivityNotifications/STKNotifications'

const Layout = ({ children }) => (
  <>
    <DocumentTitle title="LoanKeeper" />
    <div className="App">
      <OpenPagesProvider>
        <NavigationPanel />
        <div id="Content" className="App-content">
          <QuickAccessToolbar />
          {children}
        </div>
      </OpenPagesProvider>
      <StatusBar />
    </div>
    <UserActivityNotifications />
    <UserSTKNotifications />
    <ChangeDateTimeModal />
    <IconPreloader collection="general" />
  </>
)

export default Layout
